module.exports = __webpack_public_path__ + "img/6.2-Table.f0ea61e5.png";